<template>
    <div v-if="supplier">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isPembayaran ? 'Pembayaran Pinjaman Supplier' : (isKonfirmasi ? 'Konfirmasi Setoran' : 'Informasi Pinjaman Supplier') }}</h5>
            </b-card-header>
            <b-card-body v-show="isKonfirmasi">
                <p>Pembayaran pinjaman sebesar Rp. {{ pembayaran && pembayaran.nominal ? formatNumber(pembayaran.nominal) : '-' }} oleh {{ supplier.name }}.</p>
                <p>Dengan metode pembayaran {{ pembayaran && pembayaran.metode && pembayaran.metode.name ? pembayaran.metode.name.toUpperCase() : '-' }}.</p>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Supplier</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ supplier.name }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Gudang</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ supplier.gudang ? supplier.gudang.gudang.name : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal Pinjaman</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ formatDate(supplier.tanggal_pinjaman) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Pinjaman</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ formatNumber(supplier.total_pinjaman) }}</th>
                        </tr>
                        <tr v-for="(pembayaran, index) in supplier.pembayarans">
                            <th class="fit-column">{{ index ? '' : 'Detail Pembayaran' }}</th>
                            <td class="fit-column">{{ index ? '' : ':' }}</td>
                            <th class="text-primary fit-column">{{ formatDate(pembayaran.created_at) }}</th>
                            <th class="text-primary">{{ formatNumber(pembayaran.nominal) }}</th>
                            <th>
                                <button v-if="isPembayaran && $can('create pinjaman supplier pembayaran') && isSameDay(pembayaran.created_at)" type="button" title="Edit Pembayaran" @click="editPembayaran(pembayaran)" class="btn btn-link p-0" style="height: auto !important;"><i class="fas fa-pencil-alt"></i></button>
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column">Sisa Pinjaman</th>
                            <td class="fit-column">:</td>
                            <th colspan="3" class="text-primary">{{ formatNumber(supplier.total_sisa_pinjaman) }}</th>
                        </tr>
                        <tr v-if="isPembayaran">
                            <th class="fit-column">Pembayaran</th>
                            <td class="fit-column">:</td>
                            <td colspan="3">
                                <input v-validate="'required|min_value:0'" min="0" v-model="pembayaran.nominal" type="number" name="nominal" class="form-control">
                                <span class="text-danger">{{ errors.first('nominal') }}</span>
                            </td>
                        </tr>
                        <tr v-if="isPembayaran">
                            <th class="fit-column">Metode</th>
                            <td class="fit-column">:</td>
                            <td colspan="3">
                                <div class="input-group single mb-0 d-flex">
                                    <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode" v-model="pembayaran.metode" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                        label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                </div>
                                <span class="text-danger">{{ errors.first('metode') }}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="save" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="!isPembayaran" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                <button :disabled="isLoading" v-if="isPembayaran && !isKonfirmasi" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Setor</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="pembayaranForm" size="md" :hide-header="true" :hide-footer="true">
            <div v-if="currentPembayaran">
                <b-card class="m-0" no-body>
                    <b-card-header class="d-flex justify-content-between align-items-center">
                        <h5 class="modal-title">Edit Pembayaran</h5>
                    </b-card-header>
                    <b-card-body>
                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <tr>
                                    <th class="fit-column">Pembayaran</th>
                                    <td class="fit-column">:</td>
                                    <td colspan="3">
                                        <input v-validate="'required|min_value:0'" min="0" v-model="currentPembayaran.nominal" type="number" name="nominal" class="form-control">
                                        <span class="text-danger">{{ errors.first('nominal') }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="fit-column">Metode</th>
                                    <td class="fit-column">:</td>
                                    <td colspan="3">
                                        <div class="input-group single mb-0 d-flex">
                                            <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode" v-model="currentPembayaran.metode" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                                label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                        </div>
                                        <span class="text-danger">{{ errors.first('metode') }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </b-card-body>
                    <b-card-footer class="d-flex flex-row-reverse">
                        <button @click="pembayaranForm = false" type="button" class="btn btn-secondary">Batal</button>
                        <button @click="savePembayaran" type="button" class="btn btn-primary mr-2">Simpan</button>
                    </b-card-footer>
                </b-card>
            </div>
		</b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "pinjaman-viewer",

    props: {
        isPembayaran: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
    },

    data() {
        return {
            supplier: null,
            pembayaran: {
                nominal: null,
                metode: null,
            },
            currentPembayaran: null,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
            isKonfirmasi: false,
            pembayaranForm: false,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initSupplier();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.initSupplier();
        }
    },

    methods: {
        initSupplier() {
            let self = this;

            self.supplier = Object.assign({}, self.value);
        },

        print() {
            let self = this;

            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pinjaman-suppliers/print/'+self.supplier.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        save() {
            let self = this,
                data = Object.assign({}, {
                    supplier_id: self.supplier.id,
                    nominal: self.pembayaran.nominal,
                    metode: self.pembayaran.metode.name,
                });

            self.isLoading = true;
            let api = '/api/pinjaman-suppliers/pembayaran';

            self.$Progress.start();
            axios({
                method: 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        editPembayaran(pembayaran) {
            let self = this;

            self.currentPembayaran = Object.assign({}, pembayaran);
            let metodeIndex = self.metodeOptions.findIndex(option => option.name == self.currentPembayaran.metode);
            self.currentPembayaran.metode = Object.assign({}, self.metodeOptions[metodeIndex]);
            self.pembayaranForm = true;
        },

        savePembayaran() {
            let self = this,
                data = Object.assign({}, {
                    supplier_id: self.supplier.id,
                    nominal: self.currentPembayaran.nominal,
                    metode: self.currentPembayaran.metode.name,
                });

            self.isLoading = true;
            let api = '/api/pinjaman-suppliers/pembayaran/'+self.currentPembayaran.id;

            self.$Progress.start();
            axios({
                method: 'put',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.supplier = Object.assign({}, response.data.data);
                self.pembayaranForm = false;
                self.$emit('pembayaranSaved');
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
